"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorSPT = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const react_markdown_1 = require("@opsbase/react-markdown");
const react_simple_reducer_1 = require("@opsbase/react-simple-reducer");
const useDataChooserLoader_1 = __importDefault(require("@opsbase/web-data-choosers/DataChooser/useDataChooserLoader"));
const SPTChooser_1 = __importDefault(require("@opsbase/web-data-choosers/SPTChooser"));
const Divider_1 = __importDefault(require("@opsbase/web-layout/Divider"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
// eslint-disable-next-line no-shadow
var Options;
(function (Options) {
    Options["ALLOWPLAINTEXT"] = "allowCustomText";
    Options["ALLOWMULTISELECT"] = "allowMultiSelect";
})(Options || (Options = {}));
exports.QuestionEditorSPT = react_1.default.memo((props) => {
    const { config, onChange, disabled } = props;
    const [state, dispatch] = (0, react_1.useReducer)(react_simple_reducer_1.reducer, config);
    const handleChange = (0, react_1.useCallback)(field => value => dispatch({ field, value }), []);
    (0, react_1.useEffect)(() => {
        if (config !== state)
            onChange === null || onChange === void 0 ? void 0 : onChange(state);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]);
    const mutateIdLists = (0, react_1.useCallback)((items, allowed) => {
        const teams = new Set();
        const staff = new Set();
        const positions = new Set();
        items.forEach(item => {
            if ((item === null || item === void 0 ? void 0 : item.type) === DataType_1.default.STAFF) {
                staff.add(item === null || item === void 0 ? void 0 : item.id);
            }
            else if ((item === null || item === void 0 ? void 0 : item.type) === DataType_1.default.POSITION) {
                positions.add(item === null || item === void 0 ? void 0 : item.id);
            }
            else {
                teams.add(item === null || item === void 0 ? void 0 : item.id);
            }
        });
        dispatch({
            field: allowed ? `allowedPositionIds` : 'ignoredPositionIds',
            value: Array.from(positions),
        });
        dispatch({
            field: allowed ? `allowedStaffIds` : 'ignoredStaffIds',
            value: Array.from(staff),
        });
        dispatch({ field: allowed ? 'allowedTeamIds' : 'ignoredTeamIds', value: Array.from(teams) });
    }, []);
    const handleAllowedSpt = (0, react_1.useCallback)(items => mutateIdLists(items, true), [mutateIdLists]);
    const handleIgnoredSpt = (0, react_1.useCallback)(items => mutateIdLists(items), [mutateIdLists]);
    const handleAllowedWithin = (0, react_1.useCallback)((value) => {
        dispatch({ field: `allStaffAllowedWithinX`, value });
    }, []);
    const handleIgnoredWithin = (0, react_1.useCallback)((value) => {
        dispatch({ field: `allStaffIgnoredWithinX`, value });
    }, []);
    const handleChangeAllowPlainText = (0, react_1.useMemo)(() => handleChange(Options.ALLOWPLAINTEXT), [handleChange]);
    const handleChangeAllowMulti = (0, react_1.useMemo)(() => handleChange(Options.ALLOWMULTISELECT), [handleChange]);
    const p = {
        organisations: [],
        places: [],
        type: [DataType_1.default.STAFF, DataType_1.default.POSITION, DataType_1.default.TEAM],
        selectedItems: [],
        allStaffAllowedWithinX: config.allStaffAllowedWithinX,
        allStaffIgnoredWithinX: config.allStaffIgnoredWithinX,
        allowedTeamIds: config.allowedTeamIds || [],
        allowedStaffIds: config.allowedStaffIds || [],
        allowedPositionIds: config.allowedPositionIds || [],
        ignoredTeamIds: config.ignoredTeamIds || [],
    };
    const data = (0, useDataChooserLoader_1.default)(Object.assign(Object.assign({}, p), { keyword: undefined, offset: 0, limit: 50, ignoredItems: [] }));
    const allowedIds = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        if (data.loading)
            return [];
        return [
            ...((_a = config[`allowedTeamIds`]) !== null && _a !== void 0 ? _a : []),
            ...((_b = config[`allowedPositionIds`]) !== null && _b !== void 0 ? _b : []),
            ...((_c = config[`allowedStaffIds`]) !== null && _c !== void 0 ? _c : []),
        ].map(id => data.items.find(d => d.id === id));
    }, [config, data.loading, data.items]);
    const ignoredIds = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        if (data.loading)
            return [];
        return [
            ...((_a = config[`ignoredTeamIds`]) !== null && _a !== void 0 ? _a : []),
            ...((_b = config[`ignoredPositionIds`]) !== null && _b !== void 0 ? _b : []),
            ...((_c = config[`ignoredStaffIds`]) !== null && _c !== void 0 ? _c : []),
        ].map(id => data.items.find(d => d.id === id));
    }, [config, data.loading, data.items]);
    return (react_1.default.createElement(Vertical_1.default, null,
        react_1.default.createElement(Vertical_1.default, { style: { padding: 8, paddingTop: 0 } },
            react_1.default.createElement(Pane_1.default, { paddingY: true },
                react_1.default.createElement(Text_1.default, { style: { paddingVertical: 4 } }, lib_i18n_1.default.t('questiontype-spt-limit')),
                react_1.default.createElement(SPTChooser_1.default, { disabled: disabled, multi: true, value: allowedIds, onChange: handleAllowedSpt, ignoredItems: ignoredIds }),
                react_1.default.createElement(Checkbox_1.default, { disabled: disabled, checked: config.allStaffAllowedWithinX, label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('all-staff-within-x')), onChange: handleAllowedWithin })),
            react_1.default.createElement(Pane_1.default, { paddingY: true },
                react_1.default.createElement(Text_1.default, { style: { paddingTop: 12, paddingBottom: 4 } }, lib_i18n_1.default.t('questiontype-spt-hide')),
                react_1.default.createElement(SPTChooser_1.default, { disabled: disabled, multi: true, value: ignoredIds, onChange: handleIgnoredSpt, ignoredItems: allowedIds }),
                react_1.default.createElement(Checkbox_1.default, { disabled: disabled, checked: config.allStaffIgnoredWithinX, label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('all-staff-within-x')), onChange: handleIgnoredWithin })),
            react_1.default.createElement(Divider_1.default, null),
            react_1.default.createElement(Pane_1.default, { paddingY: true },
                react_1.default.createElement(Text_1.default, { variant: "small" }, "NOTE: Leave the above options empty to show all staff, teams and positions")),
            react_1.default.createElement(Divider_1.default, null),
            react_1.default.createElement(Checkbox_1.default, { disabled: disabled, checked: state.allowCustomText, color: lib_palette_1.default.secondary, onChange: handleChangeAllowPlainText, label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('allow-override-custom-text')) }),
            react_1.default.createElement(Checkbox_1.default, { disabled: disabled, checked: state.allowMultiSelect, color: lib_palette_1.default.secondary, onChange: handleChangeAllowMulti, label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('allow-multiple-selections')) }))));
});
exports.default = exports.QuestionEditorSPT;
